import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/functions';

// Read from .env (copy .env.example to .env). No hardcoded fallbacks; fail fast if config is missing.
const envKeys = {
  apiKey: 'REACT_APP_FIREBASE_API_KEY',
  authDomain: 'REACT_APP_FIREBASE_AUTH_DOMAIN',
  projectId: 'REACT_APP_FIREBASE_PROJECT_ID',
  storageBucket: 'REACT_APP_FIREBASE_STORAGE_BUCKET',
  messagingSenderId: 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  appId: 'REACT_APP_FIREBASE_APP_ID',
  measurementId: 'REACT_APP_FIREBASE_MEASUREMENT_ID',
};

const requiredEnvKeys = [
  'apiKey',
  'authDomain',
  'projectId',
  'storageBucket',
  'messagingSenderId',
  'appId',
];

function getEnvValue(envKey) {
  if (
    typeof import.meta !== 'undefined' &&
    import.meta.env &&
    import.meta.env[envKey] !== undefined
  ) {
    return import.meta.env[envKey];
  }
  if (
    typeof process !== 'undefined' &&
    process.env &&
    process.env[envKey] !== undefined
  ) {
    return process.env[envKey];
  }
  return undefined;
}

const firebaseConfig = {};
for (const key of Object.keys(envKeys)) {
  const envName = envKeys[key];
  const value = getEnvValue(envName);
  if (requiredEnvKeys.includes(key) && !value) {
    throw new Error(
      `Missing Firebase config: ${envName}. Set REACT_APP_FIREBASE_* in .env (see .env.example).`
    );
  }
  firebaseConfig[key] = value || '';
}

export const Firebase = firebase.initializeApp(firebaseConfig);
export { firebase };

// Firestore offline persistence: cache data for offline browsing and sync when back online
try {
  firebase
    .firestore()
    .enablePersistence({ synchronizeTabs: true })
    .catch(async (err) => {
      if (err.code === 'failed-precondition') {
        console.warn('Firestore persistence failed: multiple tabs open.');
      } else if (
        err.name === 'BloomFilterError' ||
        (err.message && err.message.includes('BloomFilter'))
      ) {
        console.warn(
          'Firestore BloomFilterError detected, clearing persistence...'
        );
        try {
          await firebase.firestore().clearPersistence();
          console.log('Firestore persistence cleared. Reloading page...');
          window.location.reload();
        } catch (clearErr) {
          console.error('Failed to clear persistence:', clearErr);
        }
      } else if (process.env.NODE_ENV === 'development') {
        console.warn('Firestore persistence failed:', err.message);
      }
    });
} catch (_) {}

// Firestore: create composite indexes in Firebase Console as needed for:
// products (category, createdAt), (status, createdAt), (location.state, location.city, createdAt)
// conversations (participants array-contains, lastMessageAt)
